import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent, ApSubmitTextComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApInputComponent } from '@ap/input';
import { ApPasswordInputComponent } from '@ap/input/password';

import { DigicodeHerstelComponent } from './digicode-herstel.component';

/**
 * @name DigicodeHerstelModule
 * @ngdoc module
 */
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentPipe,
        ApContentComponent,
        ApInputComponent,
        ApPasswordInputComponent,
        CommonModule,
        ReactiveFormsModule,
        ApFormControlPipe,
        ApSubmitTextComponent
    ],
    exports: [DigicodeHerstelComponent],
    declarations: [DigicodeHerstelComponent]
})
export class DigicodeHerstelModule {}
